// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.padLeft {
    padding-left: 40px;
}

.grid {
    display: grid;
    cursor: default;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
}

.firstCol {
    grid-column: 1;
}

.secondCol {
    grid-column: 2;
}

.applyButton {
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 2;
}

.treeRow:hover {
    background-color: var(--primary-color);
}

.treeLeaf {
    height: 40px;
    align-items: center;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/debugconsole/workflow/debug.workflow.settings.page.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":[".padLeft {\n    padding-left: 40px;\n}\n\n.grid {\n    display: grid;\n    cursor: default;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr;\n}\n\n.firstCol {\n    grid-column: 1;\n}\n\n.secondCol {\n    grid-column: 2;\n}\n\n.applyButton {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    z-index: 2;\n}\n\n.treeRow:hover {\n    background-color: var(--primary-color);\n}\n\n.treeLeaf {\n    height: 40px;\n    align-items: center;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
